import { Params } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewContainerRef, TemplateRef} from '@angular/core';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/filter';
import { Subscription } from 'rxjs/Subscription';

import { WidgetRegistrationComponent } from '../widget-registration/widget-registration.component';

import { WebPlatformApiService } from '../../../services/WebPlatformApiService';

import { DisplayStateService, Events } from '../../../services/DisplayStateService';

import { AppStateService } from '../../../services/AppStateService';
import { ClientSettingsService } from '../../../services/ClientSettingsService';

import { WidgetRegistration, WidgetGroup } from '../../../interfaces/UserInterfaces';

import { WidgetConfiguration, Feedback, DataPolicy } from '../../../interfaces/WidgetInterfaces';

import { FilterSpec } from '../../../classes/DataSetFilter';

import { UtilityFunctions, WindowUtils} from '../../../classes/UtilityFunctions';

import { BreadCrumb, WidgetDisplayGroup, OrderedWidget } from './classes';
import * as _ from 'lodash';

declare var $: any;

@Component({
  selector: 'app-group-display',
  template: `<div *ngIf="showBreadCrumbs" id="breadcrumb-container">
    <ol class="breadcrumb mb-1">
        <li class="breadcrumb-item" style="margin-top: 2px;">Context:</li>
        <li class="breadcrumb-item" *ngFor="let s of contextBreadCrumbs; let idx = index;" [title]="s.tooltip" (mouseover)="over(s)" (mouseleave)="over(s)" style="margin-top: 2px;">
            <div *ngIf="(s.prevValues && s.prevValues.length > 0); else elseCtxBreadCrumb" dropdown class="dropdown show" style="margin-top: -18px; margin-left: 20px;">
                <a dropdownToggle tabindex class="badge badge-primary dropdown-toggle" style="font-size: 100%; font-weight: 400;">{{s.display}} <span class="caret"></span></a>
                <div *dropdownMenu class="dropdown-menu" role="menu">
                    <a *ngFor="let pv of s.prevValues" class="dropdown-item" (click)="clickPrevContext(s.name, pv)">{{pv}}</a>
                </div>
            </div>
            <ng-template #elseCtxBreadCrumb>
                <span>{{s.display}}
                    <i *ngIf="s.close" class="fa fa-times-circle" (click)="DeleteContext(s.name)"></i>
                </span>
            </ng-template>
        </li>
        <li class="breadcrumb-menu d-md-down-none pull-right">
            <a *ngIf="!widgetAsApp" href="#" (click)="InitSelectionModal()" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#widgetSelectionModal">
                <i class="fa fa-windows" aria-hidden="true"></i>
            </a>
        </li>
    </ol>
    <ol class="breadcrumb filter mb-1">
        <li class="breadcrumb-item" style="margin-top: 2px;">Filters &amp; Sorts: </li>
        <li class="breadcrumb-item" *ngFor="let s of filterBreadCrumbs" [title]="s.tooltip" (mouseover)="over(s)" (mouseleave)="over(s)" style="margin-top: 2px;">
            <span>{{s.display}}
                <i *ngIf="s.close" class="fa fa-times-circle" (click)="DeleteFilter(s.name)"></i>
            </span>
        </li>
        <li class="breadcrumb-item" *ngFor="let s of sortBreadCrumbs" [title]="s.tooltip" (mouseover)="over(s)" (mouseleave)="over(s)" style="margin-top: 2px;">
            <span>{{s.display}}
                <i *ngIf="s.close" class="fa fa-times-circle" (click)="DeleteSort(s.name)"></i>
            </span>
        </li>
    </ol>
</div>

<div *ngIf="widgetDisplayGroups" class="container-fluid">
    <div class="row">
        <div role="tablist" *ngFor="let widgetDisplayGroup of widgetDisplayGroups; let idx = index;" [class]="widgetDisplayGroup.widthStyle + ' mb-1 group-div'">

            <div class="card" id="{{'snapable-container-' + idx}}">
                <div class="card-header" role="tab" *ngIf="widgetDisplayGroup.widgetList.length > 1  || !hideWidgetTabs">
                    <!-- Nav tabs -->

                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item" *ngFor="let OrderedWidget of widgetDisplayGroup.widgetList;  let t = index;">
                            <a class="nav-link" [ngClass]="{'active': t < 1 }" data-toggle="tab" href="{{'#grp' + idx + 'tab' + t}}" role="tab">
                                <span>{{ TabName(OrderedWidget) }}</span>

                                <span class="dropdown">
                                                        <button class="btn btn-primary" type="button" data-toggle="dropdown" id="dropdpwn-toggle-button">
                                                                <i class="fa fa-bars"  
                                                                aria-hidden="true"></i>
                                                        </button>

                                                        <div class="dropdown-menu tab-action-container" style="margin-top: 12px"  aria-labelledby="cache">
                                                                <div>
                                                                    <a class="dropdown-item d-flex justify-content-between" 
                                                                       href="javascript:;" 
                                                                       (click)="onTakePicture(idx , OrderedWidget.widgetConfiguration.name , $event)">
                                                                       Take Snapshot <i class="fa fa fa-print print-icon" aria-hidden="true"> </i>
                                                                    </a>
                                                                </div>
                                                                <div>
                                                                    <a class="dropdown-item d-flex justify-content-between" 
                                                                        href="javascript:;" 
                                                                        (click)="onCreateFeedback(OrderedWidget.widgetConfiguration)">
                                                                        Give Feedback <i class="fa fa-commenting" aria-hidden="true"> </i>
                                                                    </a>
                                                                </div>
                                                                <div>
                                                                    <a class="dropdown-item d-flex justify-content-between" 
                                                                        href="javascript:;" 
                                                                        (click)="onSeeFeedback(OrderedWidget.widgetConfiguration)">
                                                                        Watch Feedback <i class="fa fa-eye" aria-hidden="true"> </i>
                                                                    </a>
                                                                </div>
                                                                <div>
                                                                    <a class="dropdown-item d-flex justify-content-between" 
                                                                        href="javascript:;" 
                                                                        (click)="onSupportInfo(OrderedWidget.widgetConfiguration)">
                                                                        Support Information <i class="fa fa-address-book-o" aria-hidden="true"> </i>
                                                                    </a>
                                                                </div>
                                                        </div>
                                                </span>
                            </a>
                        </li>
                    </ul>
                    <div class="card-actions">
                        <button class="btn btn-primary btn-link btn-minimize" type="button" data-toggle="collapse" [attr.data-target]="'#tabset' + idx" aria-expanded="true">
                            <i class="fa fa-angle-down" title="Show"></i>
                            <i class="fa fa-angle-up" title="Hide"></i>
                        </button>
                    </div>
                </div>

                <div id="{{ 'tabset' + idx }}" class="collapse show widget-div" role="tabpanel" [style.height]="widgetDisplayGroup.heightStyle">
                    <div class="card-block">
                        <!-- Tab panes -->
                        <div class="tab-content">
                            <div class="tab-pane" [ngClass]="{'active': t < 1}" *ngFor="let OrderedWidget of widgetDisplayGroup.widgetList; let t = index;" id="{{'grp' + idx + 'tab' + t}}" role="tabpanel">
                                <!-- <app-widget-container [heightSpec]="HeightOf(widgetDisplayGroup)" [Config]="OrderedWidget.widgetConfiguration"></app-widget-container> -->
                                <ng-container *ngTemplateOutlet="widgetContainer; context: {WidgetConfiguration: OrderedWidget.widgetConfiguration}"></ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="supportModal" tabindex="-1" role="dialog" class="modal fade">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <!-- header -->
            <div class="modal-header">
                <h4 class="modal-title">Support Information for {{selectedWidget.name}}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- body -->
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12">
                            <tabset type="pills">
                                <tab *ngFor="let supportTab of supportInfo" heading="{{supportTab.name}}">
                                    <table class="table">
                                        <tbody>
                                            <tr>
                                                <td>Message</td>
                                                <td>{{supportTab.Message}}</td>
                                            </tr>
                                            <tr *ngIf="supportTab.Group">
                                                <td>Message</td>
                                                <td>{{supportTab.Group}}</td>
                                            </tr>
                                            <tr *ngIf="supportTab.NameList">
                                                <td>Personnel</td>
                                                <td>{{supportTab.NameList}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </tab>
                            </tabset>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- create feedback modal -->
<div id="feedbackModal" tabindex="-1" role="dialog" class="modal fade">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <!-- header -->
            <div class="modal-header">
                <h4 class="modal-title">Please provide your feedback for {{selectedWidget.name}}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- body -->
            <div class="modal-body">

                <div class="container-fluid">
                    <div class="row">
                        <div class="form-group col-sm-4">
                            <label for="type">Type</label>
                            <select class="form-control" size="1" [(ngModel)]="feedback.type" id="type">
                                      <option value=""> Please select the type</option>
                                      <option value="Feature">Feature</option>
                                      <option value="Bug">Bug</option>
                                      <option value="Question">Question</option>                                      
                                    </select>
                        </div>
                        <div class="form-group col-sm-4">
                            <label for="title">Title</label>
                            <input class="form-control" type="text" id="title" [(ngModel)]="feedback.title">
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label for="desc">
                                          Please Enter the description
                                      </label>
                            <textarea class="form-control" id="desc" rows="4" [(ngModel)]="feedback.desc"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <!-- footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="saveFeedback(feedback)" data-dismiss="modal">Save changes</button>
            </div>
        </div>
    </div>
</div>

<!-- create feedback modal -->

<!-- list feedback modal -->

<div id="feedbackListModal" tabindex="-1" role="dialog" class="modal fade">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <!-- header -->
            <div class="modal-header">
                <h4 class="modal-title">Feedback for {{selectedWidget.name}}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- body -->
            <div class="modal-body">

                <div class="container-fluid">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Type</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Raised By</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr *ngFor="let fb of feedbacks; let j = index">
                                <td>{{j + 1}}</td>
                                <td>{{fb.type}}</td>
                                <td>{{fb.title}}</td>
                                <td>{{fb.desc}}</td>
                                <td>{{fb.userName}}</td>
                                <td><a href="mailto:{{fb.userName}}?Subject={{selectedWidget.name}}%20:%20{{fb.title}}" target="_top">Send Mail</a></td>
                                <!-- <td>
                                      <div class="btn-group" role="group">
                                        <button id="btnGroupVerticalDrop1" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                                          aria-expanded="false">
                                                   ... Under construction ...
                                                  </button>
                                        <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                          <a class="dropdown-item" href="#">Add to Jira</a>
                                          <a class="dropdown-item" href="#">Report</a>
                                          <a class="dropdown-item" href="#">Discard</a>
                                          <a class="dropdown-item" href="#">Add Comment</a>
                                        </div>
                                      </div>
                                    </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="!feedbacks">
                        <div class="badge badge-warning">
                            <h2>
                                No Feedback available
                            </h2>
                        </div>
                    </div>
                </div>
            </div>

            <!-- footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Dismiss</button>
            </div>
        </div>
    </div>
</div>

<!-- list feedback modal -->



<div *ngIf="widgetAsApp" class="container-fluid">
    <div class="row">
        <!-- <app-widget-container [Config]="this.matchingWidgetConfigs[0]" class="widget-app"></app-widget-container> -->
        <ng-container *ngTemplateOutlet="widgetContainer; context: {WidgetConfiguration: this.matchingWidgetConfigs[0]}"></ng-container>
    </div>
</div>
<div id="widgetSelectionModal" tabindex="-1" role="dialog" class="modal fade">
    <div class="modal-dialog modal-lg " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Configure Widget Layout</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <app-widget-registration></app-widget-registration>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="SaveLayout()" data-dismiss="modal">Save changes</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.widget-div.collapsing{
    -webkit-transition:none;
    transition:none;
}

.breadcrumb{
    padding-top:1px;
    padding-bottom:0px;
    padding-right:0px;
    padding-left:8px;
    min-height:28px;
}

.breadcrumb.filter{
    padding-top:1px;
    padding-bottom:0px;
    padding-right:0px;
    padding-left:8px;
    min-height:28px;
}

.modal-lg{
    max-width:90%;
    max-height:90%;
}

.modal-lg .modal-body{
    overflow-y:auto;
}

.modal-lg .modal-body p{
    margin-bottom:900px
}

.btn-info{
    color:#fff;
    background-color:#0b406e;
}

.btn-collapse{
    color:#fff;
    background-color:#f4dc42;
}

.btn-warning{
    color:#fff;
    background-color:#804d0e;
    border-color:#eea236;
}

.group-div{
    padding:2px;
    height:calc(100% - 40px);
}

.widget-div{
    height:100%;
    width:100%;
    min-height:250px;
    overflow-x:auto;
    overflow-y:auto;
}

.breadcrumb-item.active{
    cursor:pointer;
}

.btn-minimize{
    border-left:1px solid #cfd8dc;
    height:40px;
}

i.fa-angle-down{
    display:inline-block;
    vertical-align:middle;
}

.card-block{
    padding:0.25rem;
}

.card-header{
    padding:0;
}

.card-header>ul.nav-pills{
    margin-right:1.1em
}

.card-header .card-actions{
    position:absolute;
    top:0px;
    right:0;
}

#dropdpwn-toggle-button{
    padding:0px;
    margin-left:10px;
    margin-right:-10px;
}



#feedbackButton{
    -webkit-transform:rotate(-90deg);
            transform:rotate(-90deg);
    position:fixed;
    z-index:9999;
    top:50%;
    right:-40px;
    opacity:.5;
}

#feedbackButton:hover{
    opacity:.8;
}
a.nav-link button#dropdpwn-toggle-button{
    display:none;
}
a.nav-link.active button#dropdpwn-toggle-button{
    display:inherit;
}

.tab-action-container a.dropdown-item.d-flex.justify-content-between{
    padding:3px .8rem;
}

.tab-action-container a.dropdown-item.d-flex.justify-content-between i.fa{
    margin-top:1px;
}

.btn-minimize.collapsed .fa-angle-up, .btn-minimize .fa-angle-down{
    display:none;
}

.btn-minimize.collapsed .fa-angle-down, .btn-minimize .fa-angle-up{
    display:inline-block;
}

.widget-app{
    width:100%;
    padding:15px;
    margin-bottom:150px;
}`]
})
export class GroupDisplayComponent implements OnInit, OnDestroy {
  widgetContainer = this.DisplayStateService.widgetContainer;

  @ViewChild(WidgetRegistrationComponent)
  private widgetRegistrationComponent: WidgetRegistrationComponent;

  contextBreadCrumbs: BreadCrumb[];
  filterBreadCrumbs: BreadCrumb[];
  sortBreadCrumbs: BreadCrumb[];
  statechanged$: Subscription;
  matchingWidgetConfigs: WidgetConfiguration[] = [];
  width = 'col-md-12';
  isMaximized = false;
  widgetDisplayGroups: WidgetDisplayGroup[] = [];
  tempWidgetDisplayGroup: WidgetDisplayGroup[] = [];
  hiddenWidgets: WidgetDisplayGroup[] = [];
  currentGroupContextKey: string;
  showBreadCrumbs = true;
  enablePrintMode = false;
  widgetAsApp = false;
  hideWidgetTabs: boolean;
  selectedWidget = <WidgetConfiguration>{};
  feedback = <Feedback>{};
  feedbacks: Feedback[];

  supportInfo: any[];

  constructor(private DisplayStateService: DisplayStateService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    private webPlatformApiService: WebPlatformApiService,
    private clientSettingsService: ClientSettingsService,
    private appStateService: AppStateService) {

    this.toastr.setRootViewContainerRef(vcr);

    this.DisplayStateService.DataError.subscribe(error => {
      this.toastr.error(error.ErrorMessage, `${error.widgetName} error retrieving data '${error.dataPolicy}'`);
    });

    this.DisplayStateService.Toast.subscribe(       message => { this.toastr.info(message);    });
    this.DisplayStateService.SuccessToast.subscribe(message => { this.toastr.success(message)   });
    this.DisplayStateService.WarnToast.subscribe(   message => { this.toastr.warning(message); });
    this.DisplayStateService.ErrorToast.subscribe(  message => { this.toastr.error(message);   });
    // Flag to hide  widget tabs (this is not valid if widgetDisplayGroups has more than one).
    this.hideWidgetTabs = this.clientSettingsService.HideWidgetTabs;
  }

  ngOnInit() {
    this.width = this.DisplayStateService.appState.current.widthClass;
    this.DisplayStateService.MessageHouse.subscribe(x => {
      if (Object.keys(x).indexOf('ShowConfigureWidgetLayout') > -1) {
        $('#widgetSelectionModal').modal('show');
      }
    });

    this.statechanged$ = this.DisplayStateService.AppStateChanged.subscribe(x => {
      if (x === Events.APPLICATION_READY) {
        UtilityFunctions.Log(3, "APPLICATION_READY", this.clientSettingsService, this.appStateService);
        this.BuildDisplay();
      } else  if (x === Events.CURRENT_CONTEXT_CHANGED) {
        this.BuildDisplay();
      } else if (x === Events.CURRENT_SORTS_CHANGED || x === Events.CURRENT_FILTERS_CHANGED) {
        this.BuildBreadCrumbs();
      } else if (x === Events.WIDGET_CONFIG_LIST_CHANGED) {
        this.widgetDisplayGroups = [];
        this.BuildDisplay();
      } else if (x === Events.WIDTH_CLASS_CHANGED) {
        this.SetDefaultWidth();
        this.ResetGroupWidths();
      } else if (x === Events.WIDGET_CONFIG_LIST_CHANGED) {
        this.BuildDisplay();
      } else if (x === Events.USER_CHANGED) {
        this.BuildDisplay();
      } else if (x === Events.PREFERRED_SETTINGS_CHANGED) {
        this.widgetDisplayGroups = [];
        this.BuildDisplay();
      } else if (x === Events.PRINT_PREVIEW_MODE) {
        this.enablePrintMode = this.DisplayStateService.appState.current.isPrintMode;
        this.widgetDisplayGroups = [];
        this.BuildDisplay();
      } else if (x === Events.BREADCRUMB_DISPLAYED_CHANGED) {
        if (this.DisplayStateService.appState.current.breadcrumb === 'show') {
          setTimeout(() => {
            this.showBreadCrumbs = true;
          }, 5);
        } else {
          setTimeout(() => {
            this.showBreadCrumbs = false;
          }, 5);          
        }
      }
    });
  }

  

  onSupportInfo(widget: WidgetConfiguration) {
    this.selectedWidget = widget;
    this.supportInfo = [];

    this.supportInfo.push({ 
      name: "Widget",
      Message: widget.supportMessage },
    );

    this.webPlatformApiService
      .GetConfig<DataPolicy[]>("DataPolicyList")
      .subscribe(x => {
        const dataPolicyList = x;
        if (
          widget.dataConsumerConfiguration &&
          widget.dataConsumerConfiguration.dataPolicy
        ) {
          UtilityFunctions.Log(3, `Getting data policy "${widget.dataConsumerConfiguration.dataPolicy}" for widget`, 
            this.clientSettingsService, this.appStateService);
          
          const dp = dataPolicyList.find(
            x => x.name === widget.dataConsumerConfiguration.dataPolicy
          );
          if (dp) {
            UtilityFunctions.Log(3, `Found data policy "${widget.dataConsumerConfiguration.dataPolicy}" for widget`, 
              this.clientSettingsService, this.appStateService);
            this.supportInfo.push({ 
              name: "Data: " + dp.name,
              Message: dp.supportMessage,
              Group: dp.supportGroup,
              NameList:  dp.supportNameList }
            );
          }
        }

        if (
          widget.dataConsumerConfigurations &&
          widget.dataConsumerConfigurations.length > 0
        ) {
          widget.dataConsumerConfigurations.forEach(dcc => {
            const dp = dataPolicyList.find(x => x.name === dcc.dataPolicy);
            if (dp) {
              this.supportInfo.push({ 
                name: "Data: " + dp.name,
                Message: dp.supportMessage,
                Group: dp.supportGroup,
                NameList:  dp.supportNameList }
              );
            }
          });
        }
      });

    $("#supportModal").modal("show");
  }

  onCreateFeedback(widget: WidgetConfiguration) {
    this.selectedWidget = widget;
    $('#feedbackModal').modal('show');
  }

  saveFeedback(feedback: Feedback) {
    feedback.userName = this.DisplayStateService.appState.current.user.userName;
    feedback.context = this.DisplayStateService.appState.current.context;
    this.postDataToMiddleLayer(feedback);
    this.feedback = <Feedback>{};
  }

  onTakePicture(idx: string, tabName: string, event): void {
    let snapId: string = 'snapable-container-' + idx;
    let snapshot = WindowUtils.getNativeWindowObject().document.getElementById(snapId);
    this.save(snapshot, tabName, event)
}

ClearFilterSorts() {
    this.DisplayStateService.SetFilters([]);
    this.DisplayStateService.SetSorts([]);
  }

  over(s) {
    if (!this.widgetAsApp) {
      if (event.type === 'mouseover') {
      s.close = true;
      } else if (event.type === 'mouseleave') {
      s.close = false;
      }
    }
  }
  // Button click handler when user has configured layout and wants to save what they have done.
  SaveLayout() {
    this.widgetRegistrationComponent.Save();
    this.widgetDisplayGroups = [];
    this.BuildDisplay();
  }

  InitSelectionModal() {
    this.widgetRegistrationComponent.Initialize(this.matchingWidgetConfigs);
  }

  deselected(widgetName: string) {
    this.sendWidgetMessage('deselected', widgetName);
  }

  selected(widgetName: string) {
    this.sendWidgetMessage('selected', widgetName);
  }

  sendWidgetMessage(messageName: string, widgetName: string) {

    const message: Params = [];
    message[messageName] = widgetName;
    this.DisplayStateService.MessageHouse.next(message);
  }

  WidthOf(g: WidgetDisplayGroup) {
    if(this.enablePrintMode) {
      return 'col-md-12';
    } else if (g.sourcewidgetGroup === undefined) {
      return this.width;
    } else if (g.sourcewidgetGroup.widthSpec === '*') {
      return 'col-md-12';
    } else if (g.sourcewidgetGroup.widthSpec === '5') {
      return 'col-md-12';
    } else if (g.sourcewidgetGroup.widthSpec === '4') {
      return 'col-md-8';
    } else if (g.sourcewidgetGroup.widthSpec === '3') {
      return 'col-md-6';
    } else if (g.sourcewidgetGroup.widthSpec === '2') {
      return 'col-md-4';
    } else if (g.sourcewidgetGroup.widthSpec === '1') {
      return 'col-md-3';
    }
  }

  HeightOf(g: WidgetDisplayGroup, i: number) {
    if(this.enablePrintMode) {
      return 'auto';
    } else if (g.sourcewidgetGroup === undefined) {
      return 'auto';
    } else if (g.sourcewidgetGroup.heightSpec === '*') {
      return 'auto';
    } else if (g.sourcewidgetGroup.heightSpec === '3') {
      return 'calc(100vh - 180px)';
    } else if (g.sourcewidgetGroup.heightSpec === '2') {
      return '40vh';
    } else if (g.sourcewidgetGroup.heightSpec === '1') {
      return '25vh';
    }
  }

  // edge case where widgets per row is greater than displayed widgets, so there's no point squishing the widgets and having dead space
  SetDefaultWidth() {
    const perRow = Number(this.DisplayStateService.appState.current.perRow);
    if (this.matchingWidgetConfigs.length < perRow) {
      if (this.matchingWidgetConfigs.length === 1) {
        this.width = 'col-md-12';
      } else if (this.matchingWidgetConfigs.length === 2) {
        this.width = 'col-md-6';
      } else if (this.matchingWidgetConfigs.length === 3) {
        this.width = 'col-md-4';
      } else {
        this.width = this.DisplayStateService.appState.current.widthClass;
      }
    } else {
      this.width = this.DisplayStateService.appState.current.widthClass;
    }
  }

  ResetGroupWidths() {
    if (this.widgetDisplayGroups) {
      this.widgetDisplayGroups.forEach(g => {
        if (g.sourcewidgetGroup === undefined) {
          g.widthStyle = this.width;
        }
      });
    }
  }

  ngOnDestroy() {
    this.statechanged$.unsubscribe();
  }

  DeleteContext(s: string) {
    this.DisplayStateService.RemoveContext(s);
  }

  DeleteFilter(s: string) {
    this.DisplayStateService.RemoveFilter(s);
  }

  DeleteSort(s: string) {
    this.DisplayStateService.RemoveSort(s);
  }

  onSeeFeedback(widget: WidgetConfiguration) {
    this.selectedWidget = widget;
    const filter = {
      key: widget.name
    }
    this.webPlatformApiService.GetMongoDocs('Feedback', filter).subscribe((data: any[]) => {
      this.feedbacks = undefined;
      if (data.length > 0) {
        this.feedbacks = [];
        _.forEach(data, (feedbacksPerWidget: any) => {
          const payload = feedbacksPerWidget['Payload'];
          _.forEach(payload, (feedback: Feedback) => {
            feedback['widget'] = feedbacksPerWidget['key'];
            this.feedbacks.push(feedback);
          });
        });
      }
      $('#feedbackListModal').modal('show');
    });
  }

  private postDataToMiddleLayer(feedback: Feedback) {
    const reqObj = {};
    let filter = {
      key: this.selectedWidget.name
    }
    this.webPlatformApiService.GetMongoDocs('Feedback', filter).subscribe(data => {
      if (data.length === 1) {
        data[0]['Payload'].push(feedback);
        this.makeMongoCall(data[0]);
        } else {
        const temp = [];
        temp.push(feedback);
        reqObj['Payload'] = temp;
        reqObj['key'] = this.selectedWidget.name;
        this.makeMongoCall(reqObj);
      }
    });
  }

  private makeMongoCall(data: any) {
    this.webPlatformApiService.UpsertMongoDocObs('Feedback', 'key', data).subscribe(savedData => {
      this.DisplayStateService.RaiseSuccessToast('FeedBack saved successfully - we will keep you posted with updates');
    });
  }

  private BuildBreadCrumbs() {

    let t: BreadCrumb[] = [];
    for (const key of Object.keys(this.DisplayStateService.appState.current.context)) {
      let bc = new BreadCrumb(key, `${key}: ${this.DisplayStateService.appState.current.context[key]}`, false); 
      const ctxHist = this.DisplayStateService.appState.current.contextHist.find(ch => ch.key === key);
      if (ctxHist) {
        bc.prevValues = ctxHist.prevValues;
      }
      t.push(bc);
    }
    this.contextBreadCrumbs = t
      .slice();

    t = [];
    FilterSpec.FromFilters(this.DisplayStateService.appState.current.filters).forEach(fs => {
      t.push(new BreadCrumb(fs.column, fs.formattedWhereClause, false));
    });
    this.filterBreadCrumbs = t.slice();

    t = [];
    Object.keys(this.DisplayStateService.appState.current.sorts).forEach(sk => {
      t.push(new BreadCrumb(sk, `${sk} (${this.DisplayStateService.appState.current.sorts[sk]})`, false));
    });
    this.sortBreadCrumbs = t.slice();
  }

  private WidgetDecision(wr: WidgetRegistration, wConfig: WidgetConfiguration, ctxt: Params) {
    if (UtilityFunctions.MatchWidgetConfiguration(ctxt, wConfig, this.clientSettingsService, this.appStateService)) {
      this.matchingWidgetConfigs.push(wConfig);
    }
  }

  private UserCurrentGroupedWidgets(): WidgetGroup[] {
    if (this.DisplayStateService.GroupedWidgets()) {
      return this.DisplayStateService.GroupedWidgets().filter(g => g.contextKey === this.currentGroupContextKey);
    } else {
      return [];
    }
  }

  private GetWidgetGroups(): WidgetGroup[] {
    let groupedWidgets: WidgetGroup[] = this.UserCurrentGroupedWidgets();
    if (this.enablePrintMode) {
      return [];
    } else if (groupedWidgets.length === 0) {
      groupedWidgets = this.DisplayStateService.GetPreferredSettings(this.currentGroupContextKey);
    }
    return groupedWidgets;
  }

  private HiddenGroupWidgetNames(): string[] {
    const hiddenGroup = this.GetWidgetGroups().find(g => g.hidden);

    if (hiddenGroup) {
      return hiddenGroup.widgets.map(w => w.name);
    } else {
      return [];
    }
  }

  private BuildDisplay() {

    if (! this.DisplayStateService.Ready()) {
      return;
    }

    this.BuildBreadCrumbs();

    const ctxt = this.DisplayStateService.appState.current.context;
    this.matchingWidgetConfigs = [];
    this.tempWidgetDisplayGroup = [];

    // Get Matching widgets
    this.DisplayStateService.appState.widgetConfigList.forEach(widgetConfig => {
      this.WidgetDecision(this.DisplayStateService.appState.current.userStatistics.widgetRegistration, widgetConfig, ctxt);
    });

    if (Object.keys(ctxt).length === 0) {
      const landingPageWidgets = this.DisplayStateService.appState.widgetConfigList.filter(wc => wc.name === 'Landing Page')
      if (landingPageWidgets.length > 0) {
        const wConfig = landingPageWidgets[0];
        const orderedWidget =  new OrderedWidget(wConfig, 0);
        this.matchingWidgetConfigs.push(wConfig);

        const widgetGroup: WidgetGroup = {
          contextKey: 'Landing Page',
          heightSpec: '*',
          widthSpec: '5',
          hidden: false,
          index: 0,
          widgets: [],

        };
        const group: WidgetDisplayGroup = new WidgetDisplayGroup(widgetGroup.index, widgetGroup);      

        group.widgetList = [ orderedWidget ];
        this.widgetDisplayGroups = [ group ]
      }

      this.DisplayStateService.SetAppTitle(null); // sets title back to default
      // if any widgetAsApp sideNav is shown we should remove it when we leave the app
      this.DisplayStateService.RemoveWidgetsInternalSideNav();
    }

    this.currentGroupContextKey =
      UtilityFunctions.CreateContextKey(this.matchingWidgetConfigs, this.DisplayStateService.appState.current.context);

    if (this.matchingWidgetConfigs && this.matchingWidgetConfigs.length === 1) {
      if (this.matchingWidgetConfigs[0].widgetAsApp === true) {
        this.widgetAsApp = true;
      } else {
        this.widgetAsApp = false;
      }
    } else {
      this.widgetAsApp = false;
    }
    if (this.widgetAsApp) {
      // no grouping in this view, we especially want to make the widget feel like it is it's own app within the platform.
      // keep the breadcrumbs, but lose the interaction with them, also lose the widgetSelectionModal / layout button (in template)
      // hide the widget tab group label, scrollbars and container (full width) (in template)
      // hide the sidebar
      const widgetAsAppConfig = this.matchingWidgetConfigs[0];
      // change the app title (change it back when we navigate away from this widget)
      this.DisplayStateService.SetAppTitle(widgetAsAppConfig.name);
      // if there is config setup to use an internal side nav - then we want to set it..
      if (widgetAsAppConfig.config.internalSideNavLabel && widgetAsAppConfig.config.internalSideNavComponentType) {
        // since the widget config and side nav config are loaded async we need to check if it is already loaded yet or not.
        // for the case where the side nav config was already loaded 
        if (this.DisplayStateService.appState.sideNavWidgetConfig !== undefined) {
          this.DisplayStateService.SetWidgetInternalSideNav(
            widgetAsAppConfig.config.internalSideNavLabel,
            widgetAsAppConfig.config.internalSideNavComponentType);
        } else {
          // set up a registration for the SIDE_NAV_CHANGED event so we can reset it after it loads.
          this.DisplayStateService.AppStateChanged.subscribe( event => {
            switch (event) {
              case Events.SIDE_NAV_CHANGED: {
                this.DisplayStateService.SetWidgetInternalSideNav(
                  widgetAsAppConfig.config.internalSideNavLabel,
                  widgetAsAppConfig.config.internalSideNavComponentType);
              }
            }
          });
        }
      }
    } else if (this.matchingWidgetConfigs && this.matchingWidgetConfigs.length > 0) {
      this.DisplayStateService.SetAppTitle(null); // sets title back to default
      // if any widgetAsApp sideNav is shown we should remove it when we leave the app
      this.DisplayStateService.RemoveWidgetsInternalSideNav();
      // Group them up
      const groupedWidgetNames: string[] = [];
      const widgetGroups = this.GetWidgetGroups();
      widgetGroups
        .filter(g => g.contextKey === this.currentGroupContextKey && !g.hidden)
        .sort((a, b) => a.index - b.index)
        .forEach(g => {
          const orderedWidgets: OrderedWidget[] = [];
          g.widgets
            .sort((a, b) => a.index - b.index)
            .forEach(w => {
              const matchingWC = this.matchingWidgetConfigs.find(mwc => mwc.name === w.name);
              if (matchingWC) {
                this.DisplayStateService.UserStatsIncrement(
                  this.DisplayStateService.appState.current.userStatistics.widgetUsageStatistics,
                  matchingWC.name,
                  false);
                orderedWidgets.push(new OrderedWidget(matchingWC, w.index));
                groupedWidgetNames.push(matchingWC.name);
              }
            });
          if (orderedWidgets.length > 0) {
            const group: WidgetDisplayGroup = new WidgetDisplayGroup(g.index, g);
            group.heightStyle = this.HeightOf(group, 0);
            group.widthStyle = this.WidthOf(group);

            group.widgetList = orderedWidgets;
            this.tempWidgetDisplayGroup.push(group);
          }
        });

        this.SetDefaultWidth();

      // add any ungrouped
      const ungroupedWidgets = this.matchingWidgetConfigs
        .filter(mwc => groupedWidgetNames.indexOf(mwc.name) === -1 && this.HiddenGroupWidgetNames().indexOf(mwc.name) === -1);

      let idx = 1000;
      ungroupedWidgets.forEach(ungroupedWC => {
        const group: WidgetDisplayGroup = new WidgetDisplayGroup(idx++, undefined);
        group.heightStyle = this.HeightOf(group, 0);
        group.widthStyle = this.WidthOf(group);
        group.widgetList.push(new OrderedWidget(ungroupedWC, 0));
        this.tempWidgetDisplayGroup.push(group);
      });

      if (this.tempWidgetDisplayGroup.length > 0) {
        this.DisplayStateService.SaveUserStats();
      }
    }
    // Check if the new list is different than current and, if so, rebind
    const reloadRequired = this.CheckDifferences();


    if (this.widgetAsApp && reloadRequired) {
      this.DisplayStateService.SetSideNavVisible(false);
    }

  }

  TabName(orderedWidget: OrderedWidget): string {
    if (orderedWidget && orderedWidget.widgetConfiguration) {
      return orderedWidget.widgetConfiguration.displayName  ? orderedWidget.widgetConfiguration.displayName : orderedWidget.widgetConfiguration.name;
    }
  }

  CheckDifferences() {

    let reloadRequired = false;
    if (this.widgetDisplayGroups === undefined) {
      this.widgetDisplayGroups = [];
      reloadRequired = true;
    }

    this.tempWidgetDisplayGroup.forEach((tempWdc, tempWdcIndex) => {
      if (tempWdcIndex > this.widgetDisplayGroups.length - 1) {
        this.widgetDisplayGroups.push(tempWdc);
        reloadRequired = true;
      } else {
        const existing = this.widgetDisplayGroups[tempWdcIndex];
        const temp = this.tempWidgetDisplayGroup[tempWdcIndex];
        existing.heightStyle = temp.heightStyle;
        existing.widthStyle = temp.widthStyle;
        // UtilityFunctions.Log(3, `CheckDifferences: group ${tempWdcIndex}: h = ${existing.heightStyle}, w = ${existing.widthStyle}`, this.clientSettingsService, this.appStateService);
        if (existing.widgetList === undefined) {
          existing.widgetList = [];          
        }
        temp.widgetList.forEach((ow, owIdx) => {
          if (owIdx > existing.widgetList.length - 1) {
            existing.widgetList.push(ow);
            reloadRequired = true;
          } else {
            const existingOrderedWidget = existing.widgetList[owIdx];
            const newOrderedWidget = ow;
            if (existingOrderedWidget.widgetConfiguration.name !== newOrderedWidget.widgetConfiguration.name) {
              existing.widgetList[owIdx] = ow;
              reloadRequired = true;
            }
          }
        });
        if (temp.widgetList.length < existing.widgetList.length) {
          existing.widgetList.splice(temp.widgetList.length);
          reloadRequired = true;
        }
      }
    });

    if (this.tempWidgetDisplayGroup.length < this.widgetDisplayGroups.length) {
      this.widgetDisplayGroups.splice(this.tempWidgetDisplayGroup.length);
      reloadRequired = true;
    }

    return reloadRequired;
  }

  private save(snapshot: HTMLElement, tabName: string, $event: any) {
      // $event.target.classList.add('fa-spin');
      html2canvas(snapshot).then((canvas) => {
        canvas.toBlob((blob) => {
        saveAs(blob, tabName + '.png');
        // $event.target.classList.remove('fa-spin');
      });
    });
  }

  clickPrevContext(key: string, prevContextVal: string) {
    this.DisplayStateService.AddContext(key, prevContextVal);
  }
}



export class Comment {
  commentText: string;
  userName: string;
}

declare var  html2canvas: any ;
declare var  saveAs: any ;
